module.exports = "/public/images/45ae7c93ea407ae0acab76420121203e.svg";